/*
 * Estilos y formatos compartidos por las pantallas IGI (Mi zona y ficha de tienda).
 * Los colores de nivel son los del IGI original (funcion nv() de index.html). Aqui NO se calcula
 * nada: nivel, IGI y promedios llegan calculados del backend (igi/services/scoring.py).
 */
import React from "react";

export const NIVEL_ESTILOS = {
    "Referente": {color: "#0d3b1e", background: "#c8e6c9"},
    "Fuerte": {color: "#1a5e20", background: "#e8f5e9"},
    "Estable": {color: "#7c4a00", background: "#fff8e1"},
    "Frágil": {color: "#c44a00", background: "#ffe0b2"},
    "Crítico": {color: "#8b0000", background: "#ffebee"},
    "Sin datos": {color: "#888888", background: "#f5f5f5"},
    "Sin evaluación": {color: "#888888", background: "#f5f5f5"},
};

export const estiloNivel = (nivel) => NIVEL_ESTILOS[nivel] || NIVEL_ESTILOS["Sin datos"];

// Esquema de 3 colores (distinto del de 5 niveles de arriba): el mismo que usa el backend para
// zona_color/conteo por zona (igi/services/scoring.py: fuerte >= 4, media >= 2.5, debil < 2.5). Se usa
// para el IGI promedio de una zona y para cada eje (E1/E2/E3) de una tienda, que el backend no manda
// coloreados (solo el numero).
export const NIVEL_3_ESTILOS = {
    fuerte: {color: "#1a5e20", background: "#c8e6c9"},
    media: {color: "#7c4a00", background: "#fff3cd"},
    debil: {color: "#8b0000", background: "#f8d7da"},
};

export const nivel3 = (valor) => {
    if (valor === null || valor === undefined) {
        return null;
    }
    if (valor >= 4) {
        return "fuerte";
    }
    return valor >= 2.5 ? "media" : "debil";
};

export const estilo3 = (valor) => NIVEL_3_ESTILOS[nivel3(valor)] || {color: "#888888", background: "#f5f5f5"};

export const NivelBadge = ({nivel}) => (
    <span className="badge" style={{...estiloNivel(nivel), fontWeight: 600}}>{nivel}</span>
);

const vacio = (valor) => valor === null || valor === undefined;

export const formatoNota = (valor) => (vacio(valor) ? "—" : Number(valor).toFixed(2));

export const formatoValor = (valor) => (vacio(valor) ? "—" : Number(valor).toFixed(1));

export const formatoFecha = (iso) => {
    if (!iso) {
        return "—";
    }
    const [anio, mes, dia] = iso.split("-");
    return `${dia}/${mes}/${anio}`;
};
